import Image from '@/modules/common/components/Image';

import { SafeBrandPage } from '../pages/BrandDiscountPageTemplate';

export default function BrandCard({ brand }: { brand: SafeBrandPage }) {
  return (
    <div className="flex flex-col items-center justify-center gap-6 rounded-[10px] bg-white p-6">
      <div className="flex h-[120px] w-full items-center justify-center">
        <div className="aspect-w-2 aspect-h-1 flex h-full w-[200px] items-center justify-center">
          <Image
            src={brand.brandLogo?.url || ''}
            alt={brand.brand || 'Brand Logo'}
            className="max-h-full max-w-full object-contain"
          />
        </div>
      </div>

      <span className="h-[1px] w-full bg-[#BBB9BA]"></span>
      <div className="flex w-full flex-col items-start">
        <p className="text-base font-bold">{brand.brand}</p>
        <p className="text-[#86868A]">{brand.minimumDiscount}% Min Discount*</p>
      </div>
    </div>
  );
}
